export default __webpack_public_path__ + "static/media/ic-income.e836177b.svg";